/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { IconButtonProps } from '@coursera/cds-core';

type Props = {
  iconButton: React.ReactElement<IconButtonProps>;
  buttonSize: number;
  svgSize: number;
};

const styles = {
  overrideButtonSize: (size: number) => css`
    .cds-iconButton-medium,
    .cds-iconButton-small,
    .cds-iconButton-large {
      width: ${size}px !important;
      height: ${size}px !important;
    }
  `,
  // using translate to fix imprecise svg rendering on safari
  overrideSVG: (size: number) => css`
    button svg {
      width: ${size}px;
      height: ${size}px;
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
    }
  `,
};

const IconButtonWrapper = ({ buttonSize, svgSize, iconButton }: Props) => {
  return <div css={[styles.overrideButtonSize(buttonSize), styles.overrideSVG(svgSize)]}>{iconButton}</div>;
};

export default IconButtonWrapper;
